import React from 'react';

export const ErrorDisplay = ({ error }: { error: string }) => {
    return (
        <div className='border-error bg-error-subtle rounded-lg border p-3 shadow-sm'>
            <div className='mb-2 flex items-center gap-2'>
                <div className='bg-error size-2 rounded-full' />
                <span className='caption-1-bold text-error'>Error</span>
            </div>
            <div className='caption-1-regular text-error'>{error}</div>
        </div>
    );
};
